import React from "react"
import Helmet from "react-helmet"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import SEO from "../components/seo"
import Layout from "../components/layout"
import Sublinks from "../components/sublinks"
import Infolinia from "../components/infolinia"
import ModalVideo from "../components/Modals/ModalVideo"
import IconPlay from "../images/play.svg"

import AppleStore from "../images/appstore.png"
import GooglePlay from "../images/googleplay.png"

import '../sass/main.scss'

const query = graphql`
  {
    fotka: file(relativePath: { eq: "movie-bg.jpg" }) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

const Instrukcja = () => {
  const [modVideoShow, setModVideoShow] = React.useState(false)
  const data = useStaticQuery(query)

  return (
    <Layout>
      <SEO title="ORLEN | CHARGING INSTRUCTIONS" />
      <Helmet>
        <link rel="canonical" href="https://orlencharge.pl/instrukcja-ladowania" />
      </Helmet>
      <Sublinks />

      <section className="sub-visual sub-visual-instrukcja">
        <div className="title text-center">CHARGING INSTRUCTIONS</div>
        <p className="font-xxl font-light text-center col-md-8">
          {/* Aby skorzystać z naszych ładowarek, zarejestruj / zaloguj się na
          naszej stronie */}
          To use our charger, register/log in to the&nbsp;
          <span className="font-bold color-red">ORLEN Charge</span> app on your
          phone.
        </p>
        <p className="font-xl font-light text-center col-md-8">
          To use the possibility of ad hoc charging (without registration), please use the payment terminal*
          <br/>
          <span className="font-italic font-xs">*Applies to charging stations equipped with a payment terminal</span>
        </p>
        {/* <div className="my-4">
          <a
            href="https://orlencharge.orlen.pl/#/portal/locations"
            target="_blank"
            rel="noreferrer"
            className="btn btn-primary btn-rounded"
          >
            <span className="icon-keylock mr-3 font-xl"></span> Logowanie /
            Rejestracja
          </a>
        </div>
        <p className="font-xxl font-light text-center">
          lub w aplikacji{" "}
          <span className="font-bold color-red">ORLEN Charge</span>{" "}
          w&nbsp;telefonie.
        </p> */}

        <div className="ramka my-4 my-md-5 py-4 px-2">
          <p className="font-light text-center">
            The ORLEN Charge app is available on the App Store and Google Play
            for iOS and Android
            <br />
            <br />
            <a
              href="https://apps.apple.com/us/app/orlen-charge/id1478111353"
              target="_blank"
              rel="noreferrer"
              title="zainstaluj aplikację z App Store"
            >
              <img src={AppleStore} alt="" className="img-fluid" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=pl.orlen.charge"
              target="_blank"
              rel="noreferrer"
              title="zainstaluj aplikację z Google Play"
            >
              <img src={GooglePlay} alt="" className="img-fluid" />
            </a>
          </p>
        </div>

        <Infolinia customStyle="infolinia-black d-none d-md-flex js-infolinia" />
      </section>

      <section className="charge-steps">
        <div className="container">
          <div className="row justify-content-center">
            <div
              className="col-12 col-md-4 col-lg-3 text-center ie11animfix"
              data-sal="slide-up"
              data-sal-delay="500"
              data-sal-duration="600"
              data-sal-easing="ease"
            >
              <div className="step-icon step-icon-1 mb-3 mb-xxl-5">
                <span className="icon-step-1"></span>
              </div>
              <p>
                <strong>Open the app</strong> on your phone and{" "}
                <strong>find a charging station</strong>.
              </p>
            </div>
            <div
              className="col-12 col-md-4 col-lg-3 text-center ie11animfix"
              data-sal="slide-up"
              data-sal-delay="700"
              data-sal-duration="600"
              data-sal-easing="ease"
            >
              <div className="step-icon step-icon-2 mb-3 mb-xxl-5">
                <span className="icon-step-4"></span>
              </div>
              <p>
                Before a charging session starts,{" "}
                <strong>add your payment card details</strong> in the Payment
                menu under the payment cards tab.
              </p>
            </div>
            <div
              className="col-12 col-md-4 col-lg-3 text-center ie11animfix"
              data-sal="slide-up"
              data-sal-delay="600"
              data-sal-duration="600"
              data-sal-easing="ease"
            >
              <div className="step-icon step-icon-3 mb-3 mb-xxl-5">
                <span className="icon-step-2"></span>
              </div>
              <p>
                <strong>Connect the selected charging cable</strong> to the car.
              </p>
            </div>
            <div
              className="col-12 col-md-4 col-lg-3 text-center ie11animfix"
              data-sal="slide-up"
              data-sal-delay="700"
              data-sal-duration="600"
              data-sal-easing="ease"
            >
              <div className="step-icon step-icon-4 mb-3 mb-xxl-5">
                <span className="icon-step-3"></span>
              </div>
              <p>
                <strong>Select the appropriate connector</strong> by tapping the
                Charge button in the app.
              </p>
            </div>

            <div
              className="col-12 col-md-4 col-lg-4 text-center ie11animfix"
              data-sal="slide-up"
              data-sal-delay="800"
              data-sal-duration="600"
              data-sal-easing="ease"
            >
              <div className="step-icon step-icon-5 mb-3 mb-xxl-5">
                <span className="icon-step-5"></span>
              </div>
              <p>
                <strong>
                  In order to stop the charging session, press the Stop button
                </strong>{" "}
                in the app. The charger will release the plug in your vehicle.
              </p>
            </div>

            <div
              className="col-12 col-md-12 col-lg-4 text-center ie11animfix"
              data-sal="slide-up"
              data-sal-delay="700"
              data-sal-duration="600"
              data-sal-easing="ease"
            >
              <div className="step-icon step-icon-6 mb-3 mb-xxl-5">
                <span className="icon-step-7"></span>
              </div>
              <p>
                The total cost will be calculated after the charging session is
                completed.
              </p>
            </div>
            <div
              className="col-12 col-md-4 col-lg-4 text-center ie11animfix"
              data-sal="slide-up"
              data-sal-delay="900"
              data-sal-duration="600"
              data-sal-easing="ease"
            >
              <div className="step-icon step-icon-7 mb-3 mb-xxl-5">
                <span className="icon-step-6"></span>
              </div>
              <p>
                Be considerate of other drivers –{" "}
                <strong>leave the parking space</strong> as soon as you have
                finished charging.
              </p>
            </div>
          </div>
        </div>
      </section>

      <BackgroundImage
        Tag="section"
        className={`section-movie`}
        fluid={data.fotka.childImageSharp.fluid}
        backgroundColor={`#000`}
      >
        <div className="bg-overlay"></div>
        <div
          className="col-10 col-md-6 text-center section-movie-text ie11animfix"
          data-sal="slide-up"
          data-sal-delay="500"
          data-sal-duration="600"
          data-sal-easing="ease"
        >
          <h4>How to use ORLEN chargers?</h4>
          <div className="mt-5">
            <button className="btn-play" onClick={() => setModVideoShow(true)}>
              <img src={IconPlay} alt="" className="img-fluid" />
            </button>
          </div>
        </div>
      </BackgroundImage>
      <ModalVideo
        show={modVideoShow}
        handleclose={() => setModVideoShow(false)}
      />

      <section className="charge-details">
        <div className="container">
          <div className="row justify-content-md-around">
            <div
              className="col-12 col-md-4 col-xl-3 ie11animfix"
              data-sal="slide-up"
              data-sal-delay="500"
              data-sal-duration="600"
              data-sal-easing="ease"
            >
              <figure>
                <span className="icon-instrukcja-1"></span>
              </figure>
              <p className="text-center">
                <strong>
                  Check out full details and status of your charging session in
                  the app or on the charger screen.
                </strong>
              </p>
            </div>
            <div
              className="col-12 col-md-4 col-xl-3 ie11animfix"
              data-sal="slide-up"
              data-sal-delay="600"
              data-sal-duration="600"
              data-sal-easing="ease"
            >
              <figure>
                <span className="icon-instrukcja-2"></span>
              </figure>
              <p className="text-center">
                Respect other drivers:
                <br />
                <strong>Never unplug another car</strong> while it’s charging.
              </p>
            </div>
            <div
              className="col-12 col-md-4 col-xl-3 ie11animfix"
              data-sal="slide-up"
              data-sal-delay="700"
              data-sal-duration="600"
              data-sal-easing="ease"
            >
              <figure>
                <span className="icon-instrukcja-3"></span>
              </figure>
              <p className="text-center">
                Respect other drivers:
                <br />
                <strong>
                  Don’t leave your car plugged in longer than necessary.
                </strong>
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}
export default Instrukcja



